import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/hooks/store/useAuth";

export const useIsNotGuest = () => {
  const navigate = useNavigate();
  const { authState } = useAuth();

  useEffect(() => {
    switch (authState) {
      case "unauthenticated":
        navigate("/");
        break;
      default:
        break;
    }
  }, [navigate, authState]);
};
